import { IManhattanBundleSubmit, ISelectedOTTProduct } from "./types";

export default class BundleData implements IManhattanBundleSubmit {

  segment: string;
  selectedProducts: ISelectedOTTProduct[];
  lang: string;

  constructor(
    segment: string,
    selectedProducts: ISelectedOTTProduct[],
    lang: string
  ) {
    this.segment = segment;
    this.selectedProducts = selectedProducts;
    this.lang = lang;
  }

}
